import { render, staticRenderFns } from "./VendorFilter.vue?vue&type=template&id=8f164274"
import script from "./VendorFilter.vue?vue&type=script&lang=js"
export * from "./VendorFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports